class AppError {
    constructor(title='', text='') {
        this.title = title
        this.text = text
    }
}

export default AppError



// WEBPACK FOOTER //
// ./src/models/AppError.js